let lastScroll = 0

const ReaderHeader = {
  name: 'page-header',
  props: ['forceVisible'],
  data() {
    return {
      active: false,
      showHeader: false,
      interval: null
    }
  },
  computed: {
    logoClasses() {

      if (!this.active) return {
        'logo--displace': false,
        'logo--hidden-mobile': false
      }

      return {
        'logo--displace': !this.showHeader
      }

    },
    graphicNavClasses() {

      if (!this.active) return {
        'graphic-nav--inactive': true
      }

      return {
        'graphic-nav--displace': !this.showHeader
      }

    },
    headerClasses() {

      if (!this.active) return {
        'header--hidden': true
      }

      return {
        'header--hidden': !this.showHeader
      }

    }
  },
  methods: {
    checkScroll() {

      const thisScroll = (window.pageYOffset || document.documentElement.scrollTop)  - (document.documentElement.clientTop || 0)

      if (thisScroll > lastScroll) {

        this.showHeader = false

        lastScroll = thisScroll - 10

      } else if(thisScroll < lastScroll) {

        this.showHeader = true

        lastScroll = thisScroll + 10

      }

    },
    activate(forceShow) {

      lastScroll = 0

      setTimeout(() => {
        this.active = true
        this.interval = setInterval(this.checkScroll, 250)
        if (forceShow) this.showHeader = true
      }, 500)

    },
    deactivate() {

      this.active = false

      lastScroll = 0

      clearInterval(this.interval)

    }
  },
  mounted() {

  },
  template: `
    <div>

      <a href="http://reprecdigit.se">
        <h1 class="logo" :class="logoClasses">R/R/D</h1>
      </a>

      <div id="graphic-nav" :class="graphicNavClasses">

        <router-link to="/jesper-olsson/part-1" class="graphic-nav-item graphic-nav-item--current">
          <div class="graphic-nav-item-inner graphic-nav-item-inner--jesper"></div>
          <p class="graphic-nav-description">List → Program → Ecology:<br>Post-Digital in Swedish Poetry<br>Jesper Olsson</p>
        </router-link>

        <div class="graphic-nav-item--inactive">
          <div class="graphic-nav-item-inner graphic-nav-item-inner--cilla"></div>
          <p class="graphic-nav-description">Title<br>Subtitle<br>Cecilia Lindhé</p>
        </div>

        <div class="graphic-nav-item--inactive">
          <div class="graphic-nav-item-inner graphic-nav-item-inner--jonas"></div>
          <p class="graphic-nav-description">Title<br>Subtitle<br>Jonas Ingvarsson</p>
        </div>

        <div class="graphic-nav-item--inactive">
          <div class="graphic-nav-item-inner graphic-nav-item-inner--jakob"></div>
          <p class="graphic-nav-description">Title<br>Subtitle<br>Jakob Lien</p>
        </div>

      </div>

      <header id="header" :class="headerClasses" :style="{ backgroundColor: this.accentColor }">

        <div class="header-border"></div>

        <div class="header-grid">

          <div class="header-group">

            <router-link to="/">
              <h2 class="header-part-book">Part B(OOK)</h2>
            </router-link>

            <router-link to="/" class="header-mobile-back">&larr; Back</router-link>

            <hr>

            <h1 class="header-three-line-h1">List &rarr; <br>Program &rarr; <br>Ecology:</h1>

            <p class="small-text">Post-Digital in Swedish Poetry</p>

            <figure class="header-mobile-illustration">

              <div class="header-illustration header-illustration--jesper"></div>

            </figure>

            <hr>

            <p class="small-text">Jesper Olsson</p>

          </div>

        </div>

      </header>

    </div>
  `
}

export default ReaderHeader
